import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { SystemOptionType } from 'data/types';
import { isRecommendationReason } from './recommendation-reasons';

type SystemRecommendationReasonsProps = Readonly<{
  system: SystemOptionType;
}>;

export default function SystemRecommendationReasons({
  system
}: SystemRecommendationReasonsProps) {
  const reasons = system.tags.filter(isRecommendationReason);

  if (reasons.length === 0) {
    return null;
  }

  return (
    <div className='rounded-lg border border-green-200 bg-green-50 p-4'>
      <div className='text-xs font-semibold uppercase tracking-wider text-green-800'>
        Why we recommend this system
      </div>
      {/* TODO: design dedicated "why we recommend" reasoning, currently piggybacking on option.tags. */}
      <ul className='mt-2 space-y-1 text-sm text-gray-700'>
        {reasons.map((tag) => (
          <li key={tag} className='flex items-start gap-2'>
            <CheckCircleIcon className='mt-0.5 h-4 w-4 shrink-0 text-green-500' />
            <span>{tag}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
